// Flag to prevent adding multiple event listeners
let accordionInitialized = false;

function accordionFunction() {
  if (accordionInitialized) return; // Exit if already initialized

  const accordionHeaders = document.querySelectorAll('.accordion-mobile');

  accordionHeaders.forEach(header => {
    // Define event handler functions
    function clickHandler() {
      const parent = header.parentElement;
      console.log('Footer menu click');
      parent.classList.toggle('active');
      const expanded = parent.classList.contains('active');
      header.setAttribute('aria-expanded', expanded);
      const content = header.nextElementSibling;
      content.setAttribute('aria-hidden', !expanded);
    }

    function keydownHandler(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        header.click();
      }
    }

    // Add event listeners
    header.addEventListener('click', clickHandler);
    header.addEventListener('keydown', keydownHandler);

    // Store handlers for later removal
    header._clickHandler = clickHandler;
    header._keydownHandler = keydownHandler;

    // Initialize ARIA attributes
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'false');
    const content = header.nextElementSibling;
    content.setAttribute('aria-hidden', 'true');
  });

  accordionInitialized = true; // Set the flag
}

function removeAccordionFunction() {
  if (!accordionInitialized) return; // Exit if not initialized

  const accordionHeaders = document.querySelectorAll('.accordion-mobile');
  accordionHeaders.forEach(header => {
    // Remove event listeners using stored references
    if (header._clickHandler) {
      header.removeEventListener('click', header._clickHandler);
      delete header._clickHandler;
    }
    if (header._keydownHandler) {
      header.removeEventListener('keydown', header._keydownHandler);
      delete header._keydownHandler;
    }

    // Reset ARIA attributes
    header.removeAttribute('role');
    header.removeAttribute('tabindex');
    header.removeAttribute('aria-expanded');
    const content = header.nextElementSibling;
    content.removeAttribute('aria-hidden');
  });

  accordionInitialized = false; // Reset the flag
}

function checkScreenSize() {
  if (window.innerWidth <= 1024) {
    accordionFunction();
  } else {
    removeAccordionFunction();
  }
}

document.addEventListener('DOMContentLoaded', checkScreenSize);
window.addEventListener('resize', checkScreenSize);
